import { CurrentUserProfile } from "./CurrentUserProfile";
export default CurrentUserProfile;
